module.exports = __webpack_public_path__ + "img/formats-1.97c1cb9f.png";